import axios from "axios";

// Standalone axios instance for the public migration request page.
// Intentionally does NOT share interceptors or credentials with the
// authenticated DMS API client.
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (!window.location.port || window.location.port === "80" || window.location.port === "443") {
    return "/api";
  }
  return `http://${window.location.hostname}:8000`;
};

const publicApi = axios.create({
  baseURL: getApiUrl(),
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

export default publicApi;
